/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_S1Inputs */

const en_tut_paket_s1 = /** @type {(inputs: Tut_Paket_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Paket & tagihan**. Every member may look; only admins can change the plan.`)
};

const id_tut_paket_s1 = /** @type {(inputs: Tut_Paket_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Paket & tagihan**. Semua anggota boleh melihatnya; hanya admin yang bisa mengubah paket.`)
};

/**
* | output |
* | --- |
* | "Open **Paket & tagihan**. Every member may look; only admins can change the plan." |
*
* @param {Tut_Paket_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_s1 = /** @type {((inputs?: Tut_Paket_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_s1(inputs)
	return en_tut_paket_s1(inputs)
});